import React from "react";
import ReactHtmlParser from 'react-html-parser';
import { Button, Loader, Row, Container, Card, Form, Input, FormField } from "kepler";
import { Success, Revoked, Inprogress } from '../components/getStarted';
import { parseMessages } from '../../../utilityHelper';

const templateData = $('body').data();
const lang = $('html').attr('lang');
const propertyInfo = parseMessages('ppcc/confirmation/confirmation-home');

export default class TokenCollection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationState : (this.props.confirmationStatus) ? this.props.confirmationStatus.state : templateData.confirmationStatus.state,
            tokenError: false,
            tokenValidationError: false,
            loader: false,
            techsouptoken: ''
        };
        this.onTokenSubmit = this.onTokenSubmit.bind(this);
    }
    onTokenSubmit(){
        var validtoken = this.validateToken();
        let csrf = $('body').attr('data-csrf');
        let policy_id = '';
        let confirmationStatus = (this.props.confirmationStatus) ? this.props.confirmationStatus : templateData.confirmationStatus;
        if (confirmationStatus.tech_soup_data){
            policy_id = (confirmationStatus.tech_soup_data.policy_id) ? confirmationStatus.tech_soup_data.policy_id : '';
        }
        let params = {
            token : $('#techsouptoken').val(),
            policy_id : policy_id,
            _csrf: csrf
        }
        this.setState({
            tokenError: false,
            tokenValidationError: false,
            loader: true
        });
        if (validtoken) {
            $.post('/givingfund/ppcc/confirmcharityaccount', params, (result) => { 
              if(result.result){
                this.setState({
                    confirmationState: result.status,
                    tokenError: false,
                    loader: false
                });
               } else {
                    $('#techsouptoken').focus();
                    this.setState({
                        confirmationState: result.status,
                        tokenError: true,
                        loader: false
                    });
               }
            });
        } else {
            $('#techsouptoken').focus();
            this.setState({
                tokenValidationError: true,
                tokenError: false,
                loader: false
            });
        }
    }

    validateToken() {
        let regex = /^[0-9a-zA-Z\_-]+$/,
            token = $("#techsouptoken").val(),
            tokenHandle = token.split('@'),
            result = regex.test(tokenHandle[1]);
        if (tokenHandle[1] && ((tokenHandle[1].length < 3) || (tokenHandle[1].length > 16))) {
            return false;
        } else if (tokenHandle[1] && result) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        let tokenError = (this.state.tokenError || this.state.tokenValidationError) ? 'tokenError' : '',
        showInvalidtokenMsg='',
        validationTokenErrMsg='';
        const tokenExample = propertyInfo.tokencollect.example,
            tokenUrl = 'https://app.ngok.techsoupglobal.org/Default.aspx?vendorAppId=ded55a9d-8d12-491d-8baa-14253a1e73e0&country=CA&language=' + lang;

        if (this.state.tokenError) {
            showInvalidtokenMsg = (
                <div><p className="invalidtokenMsg">{propertyInfo.tokencollect.invalidtokenerror}</p></div>
            );
        }
        if (this.state.tokenValidationError) {
            validationTokenErrMsg = (
                <div><p className="invalidtokenMsg">{propertyInfo.tokencollect.validationTokenErr}</p></div>
            );
        }
        if (this.state.confirmationState === 'Confirmed') {
            return (<Success/>);
        } else if (this.state.confirmationState === 'Revoked') {
            return (<Revoked/>);
        } else if (this.state.confirmationState === 'In Progress') {
            return (<Inprogress/>);
        } else {
            return (
                <div>
                <Container
                    id="ConfirmCharityWapper"
                    maxWidth={800}
                    className="container"
                >
                    <Row>
                        <Card id="setupConfirmation" className="roundedBox">
							<div className="bodyContainer">
	                            <p className="titleImg"><img src="https://www.paypalobjects.com/webstatic/ppgf/ppcc/techsoup-logo.svg" width="150px"/></p>
	                            <h3>{propertyInfo.tokencollect.title}</h3>
	                            <Form type="inline">
	                                <Input label={propertyInfo.tokencollect.inputlabel} id="techsouptoken" className={tokenError} value={this.state.techsouptoken} onChange={value => this.setState({ techsouptoken: value })}/>
                                    {showInvalidtokenMsg}
                                    {validationTokenErrMsg}
	                                <p className="vx_text-legal">{propertyInfo.tokencollect.info}</p>
                                    <p className="vx_text-legal">{ ReactHtmlParser(tokenExample) }</p>
                                    <p className="vx_text-legal">{propertyInfo.tokencollect.expiremsg}</p>
	                                <FormField>
	                                    <Button onClick={this.onTokenSubmit} id="submitToken">{propertyInfo.tokencollect.continue}</Button>
	                                </FormField>
	                            </Form>
	                            <p className="divideWithOr"><span>{propertyInfo.tokencollect.or}</span></p>
	                            <Button type="secondary" className = "techsoupNavigator" href={tokenUrl} target="_blank">{propertyInfo.tokencollect.getatoken}</Button>
							</div>
                        </Card>
                    </Row>
                    <Loader show={this.state.loader} priority={10} type="fixed" size="lg"></Loader>
                </Container>
                </div>
            );
        }
    }

}



// WEBPACK FOOTER //
// ./ppcc/confirmation/components/tokenCollection.js